export function createOptimisticApprovalQueue({ remove, restore }) {
  const snapshots = new Map();

  return {
    apply(approval) {
      snapshots.set(approval.id, approval);
      remove(approval.id);
    },

    rollback(id) {
      const approval = snapshots.get(id);

      if (approval) {
        restore(approval);
      }

      snapshots.delete(id);
    },

    commit(id) {
      snapshots.delete(id);
    }
  };
}